import React from "react";
import PropTypes from "prop-types";
import Radio from "@mui/material/Radio";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import { colors } from "../config/colors";

const CustomRadioStyled = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    ...theme.typography.subtitle2,
    textAlign: "left",
  },
}));

const ActiveRadio = styled(Radio)(() => ({
  color: colors.border,
  "& .Mui-checked": {
    color: colors.primary,
  },
}));

export const CustomRadioButton = ({
  label = "",
  isChecked = false,
  disabled = false,
  onClick = null,
}) => {
  return (
    <CustomRadioStyled
      value={label}
      control={disabled ? <Radio /> : <ActiveRadio />}
      checked={isChecked}
      disabled={disabled}
      onChange={disabled ? null : onClick}
      label={label}
    />
  );
};

CustomRadioButton.propTypes = {
  label: PropTypes.string,
  isChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};
